import { useMemo } from "react";
import { useLocation } from "react-router-dom";

const BOOKING_PATH = "/booking";

export const useIsExternalUsage = (): boolean => {
  const { pathname } = useLocation();
  return useMemo<boolean>(() => !pathname.startsWith(BOOKING_PATH), [pathname]);
};
